export default __webpack_public_path__ + "static/media/element_25.4ccc4e56.webp";